module.exports = __webpack_public_path__ + "img/instagram-shop.53d9afe9.png";